module.exports = __webpack_public_path__ + "static/media/undo.f397832f.svg";